import styled from "styled-components"

import { ContainerWithColor } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/ContainerWithColor/ContainerWithColor"

export const SubpageContainer = styled(ContainerWithColor)`
    background-color: #ffffff;
    border-radius: 16px;
    border: 1px solid #e9ecef;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.12);

    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    max-width: 720px;
    margin: 1.5rem auto 0 auto;

    padding: 1.5rem;

    font-size: 16px;

    @media (min-width: 768px) {
        padding: 2rem;
    }
`

export const LoadingContainer = styled(SubpageContainer)`
    align-items: center;
    justify-content: center;
`

export const Wrapper = styled.div`
    padding: 2rem;
    @media (max-width: 768px) {
        padding: 1.5rem;
    }
`

export const NextElectionBannerWrapper = styled.div``

export const EmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 3rem 1.5rem;
    gap: 4px;
`

export const EmptyStateIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    border-radius: 50%;
    color: var(--plum-gray-5);
    font-size: 28px;
`

export const EmptyStateTitle = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: var(--plum-black);
    margin: 0;
    line-height: 1.4;
`

export const EmptyStateDescription = styled.p`
    font-size: 14px;
    color: var(--plum-gray-7);
    margin: 0;
    line-height: 1.5;
    max-width: 500px;
`
